// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__mhoAq","tooltip":"Tooltip_tooltip__0lHyH"};